<template>
  <WdsAlert v-if="store.isEditable" :hidden="!store.paymentRequestForm.dateStart">
    {{ $t("Here's a breakdown") }}
    <template #description>
      {{ $tc(':count day total | :count days total', Number(dateRange.days)) }}:
      {{ dateRange.week_days }}x {{ $t('Monday') }}-{{ $t('Friday') }},
      {{ dateRange.weekend_days }}x {{ $t('Saturday') }} & {{ $t('Sunday') }}
    </template>
  </WdsAlert>
</template>

<script setup lang="ts">
import { WdsAlert } from '@worksome/wds-components'
import { computed } from 'vue'
import moment from 'moment'
import { useTranslation } from '@/composables/translation'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import useDateRange from '@/composables/useDateRange'

const { $t, $tc } = useTranslation()
const store = usePaymentRequestStore()

const dateRange = computed(() => {
  const range = useDateRange(
    moment(store.paymentRequestForm.dateStart, 'YYYY-MM-DD'),
    store.paymentRequestForm.dateEnd
      ? moment(store.paymentRequestForm.dateEnd, 'YYYY-MM-DD')
      : undefined,
  )
  return range.value
})
</script>
